import React, { Component } from 'react';

class ProductNotSave extends Component {
  render() {
    const { onClickYes, onMessage } = this.props;
    return (
      <div
        className="modal fade theme-modal" id="ProductNotSaveModal"
        tabIndex="-1" aria-labelledby="ProductNotSaveModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              {
                onMessage !== ''
                  ? (
                    <p>{onMessage}</p>
                  )
                  : (
                    <p>
                      Products have already been processed for this case.
                      Ask the office to reopen the case in order to submit additional products.
                    </p>
                  )
              }
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onClickYes()}
                  >OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductNotSave;
